import {PatientInsuranceCoverageDataModel} from '../patient/patient-insurance-coverage-data.model';
import {FeeScheduleItemFeeDataModel} from '../fee-schedule/fee-schedule-item-fee-data.model';

export class PatientInsuranceCoverageARDataModel extends PatientInsuranceCoverageDataModel {
  DATA_DoctorFees: FeeScheduleItemFeeDataModel[];
}
